// eslint-disable-next-line boundaries/element-types
import { ComponentType } from '@angular/cdk/overlay';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { TellentMember } from '@core/tellent-types';
import { DialogConfigOptions, IconName } from '@core/user-interface-legacy';

export interface AddEmployeeForPreonboardingPayload {
  members: Array<{
    personalEmail: string;
    firstName: string;
    lastName: string;
  }>;
  seats: Array<{
    appGuid: string;
    access: boolean;
    roleExternalId: string;
  }>;
  sendInvitation: boolean;
}

export interface AddEmployeeWithoutAccessPayload {
  members: Array<{
    firstName: string;
    lastName: string;
    email: string;
    personalEmail: string;
  }>;
  seats: Array<{
    appGuid: string;
    access: boolean;
    roleExternalId: string;
  }>;
  sendInvitation: boolean;
}

export interface UserInvitationData {
  displayAutj?: boolean;
  payload?: TellentMember[];
  startPreonboarding?: boolean;
  inviteMethod?: InviteMethod | null;
  loginType?: LoginType | null;
}

export interface UserInvitationStepI {
  dialogComponent: ComponentType<any>;
  dialogConfig: DialogConfigOptions;
}

export enum InviteMethod {
  Email = 'email',
  Login = 'login',
}

export enum LoginType {
  Auto = 'auto',
  Custom = 'custom',
}

export type AddMemberForm = {
  inviteMethod: FormControl<InviteMethod | null>;
  loginType: FormControl<LoginType | null>;
  members: FormArray<FormGroup<MemberFormField<{}>>>;
  seats: FormGroup<{
    recruitee: FormGroup<SeatType>;
    kiwi: FormGroup<SeatType>;
  }>;
  sendInvitation: FormControl<boolean | null>;
};

export type MemberFormField<T> = {
  email: FormControl<string | null>;
  firstName: FormControl<string | null>;
  lastName: FormControl<string | null>;
  login: FormControl<string | null>;
} & T;

export type SeatType = {
  toggle: FormControl<boolean | null>;
  appGuid: FormControl<string | null>;
  roleExternalId: FormControl<string | null>;
};

// export type UserInvitationPayload = {
//   members: Array<
//     Pick<TellentMember, 'workEmail' | 'personalEmail' | 'firstName' | 'lastName' | 'extraPayload'>
//   >;
//   seats: Array<Pick<Seat, 'appGuid' | 'access' | 'roleExternalId'>>;
//   sendInvitation: boolean;
// };

export enum UserInvitationFlow {
  InviteMemberBasic = 'invite_member_basic',
  InviteMemberAdvanced = 'invite_member_advanced',
  AddEmployeeForPreonboarding = 'add_employee_for_preonboarding',
  AddEmployeeWithoutAccess = 'add_employee_without_access',
}

export interface AddMemberFlowSelectionCardI {
  heading: string;
  subheading: string;
  icon: IconName;
  flowType?: UserInvitationFlow;
}

export interface StepDefinition {
  step: UserInvitationStep;
  canMatch?: (data: Partial<UserInvitationData>) => boolean;
  initialData?: any;
}

export type UserInvitationStep =
  | 'add_member'
  | 'add_member_new'
  | 'add_employee_for_preonboarding'
  | 'add_employee_without_access'
  | 'assign_members_to_jobs'
  | 'member_added_success'
  | 'download_credentials'
  | 'subdomain_information'
  | 'journey_promo_dialog';
